<template>
  <div class="risk-tags">
    <nr-tag
      v-if="!!reviewStatus"
      :label="statusText"
      :tag-color="statusColor"
      :clickable="manage"
      :iconPosition="iconPosition"
      :icon="icon"
      @on-click="handleOnReviewClick"
    />
    <nr-tag :label="severityText" :tag-color="severityColor" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import NrTag from '@nextrequestco/components/src/components/NrTag'
import {
  ColorizedDocumentSeverity,
  DocumentSeverity,
  HumanizedDocumentSeverity,
  humanizedSeverityStatus,
  severityStatusColor
} from '../../pages/admin/document_severity_status'
import {
  ColorizedDocumentReviewStatus,
  DocumentReviewStatus,
  HumanizedDocumentReviewStatus,
  humanizedReviewStatus,
  reviewStatusColor
} from '../../pages/admin/document_review_status'

export default defineComponent({
  components: {
    'nr-tag': NrTag
  },
  props: {
    scanId: { type: Number as PropType<number> },
    manage: { type: Boolean as PropType<boolean> },
    reviewStatus: { type: String as PropType<DocumentReviewStatus | void> },
    severity: { type: String as PropType<DocumentSeverity | void> }
  },
  data() {
    return {
      status: ''
    }
  },
  computed: {
    icon(): void | string {
      return this.manage ? 'check' : undefined
    },
    iconPosition(): void | 'left' {
      return this.manage ? 'left' : undefined
    },
    statusText(): HumanizedDocumentReviewStatus {
      return humanizedReviewStatus(this.reviewStatus)
    },
    statusColor(): ColorizedDocumentReviewStatus {
      return reviewStatusColor(this.reviewStatus)
    },
    severityText(): HumanizedDocumentSeverity {
      return humanizedSeverityStatus(this.severity)
    },
    severityColor(): ColorizedDocumentSeverity {
      return severityStatusColor(this.severity)
    }
  },
  methods: {
    handleOnReviewClick(): void {
      if (!this.manage) return
      this.$emit('on-review-status-click')
    }
  }
})
</script>

<style lang="scss">
.tag-element {
  position: relative;
  margin: 0 0.125rem;
  font-weight: unset;

  .tag-icon-btn {
    padding: 0.125em 0.375em;
  }
}
</style>
